import { createReducer, on } from '@ngrx/store';
import { Initiative } from '../../models';
import * as utility from '../../../utility';
import * as InitiativeActions from '../actions/my-initiatives.action';
import { PageData } from 'src/app/core/models';

export interface MyInitiativesState {
  entities: { [id: number]: Initiative };
  loading: boolean;
  loaded: boolean;
  error?: any;
}

export const initialState: MyInitiativesState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const MyInitiativeReducer = createReducer(
  initialState,
  on(InitiativeActions.LoadMyInitiatives, (state: MyInitiativesState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(InitiativeActions.LoadMyInitiativesSuccess, (state: MyInitiativesState, { initiatives }) => {
    const entities = utility.ToEntities(initiatives, 'id', state.entities);

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(InitiativeActions.LoadMyInitiativesFail, (state: MyInitiativesState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getMyInitiativesEntities = (state: MyInitiativesState) => state.entities;
export const getMyInitiativesLoading = (state: MyInitiativesState) => state.loading;
export const getMyInitiativesLoaded = (state: MyInitiativesState) => state.loaded;
export const getMyInitiativesError = (state: MyInitiativesState) => state.error;
